import { FileData, ResultData } from "@nt-portal/common-sdk";
import { IExcelField, ReportParameters, TCMResponseDataItem, TCMResponseReportService } from "@nt-portal/tcm-sdk";
import { BaseClientService } from "../../base-client.service";

export class ClientTCMResponseReportService extends BaseClientService {

    private _service: TCMResponseReportService;


    constructor() {
        super();
        this._service = new TCMResponseReportService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async reportData(params: ReportParameters, reportType: string): Promise<ResultData<TCMResponseDataItem>> {
        return await this._service.reportData(this.token, params, reportType);
    }

    public async reportColumns(params: ReportParameters, reportType: string): Promise<IExcelField[]> {
        return await this._service.reportColumns(this.token, params, reportType);
    }

    public async exportReport(params: ReportParameters, reportType: string): Promise<FileData> {
        return await this._service.reportExport(this.token, params, reportType);
    }




}
